import React, { useState, useEffect } from "react";
import { Button, Dialog, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./PendingActionPrompt.module.scss";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    width: 600,
    maxWidth: 600,
  },
});

const StyledGrid = styled(Grid)({
  width: 600,
  maxWidth: 600,
});

const PendingActionPrompt = (props) => {
  const [open, setOpen] = useState(props.open);

  useEffect(() => {
    if (props.open !== open) {
      setOpen(props.open);
    }
  }, [props.open, open]);

  return (
    !props.disabled && (
      <StyledDialog
        open={open}
        onClose={props.onClose}
        data-testid="pendingActionPrompt"
      >
        <StyledGrid
          container
          className={`pagePadding ${styles.container}`}
          justifyContent="center"
        >
          <Grid item xs={10} className={styles.title}>
            <div>{props.t("PendingActionPrompt.title")}</div>
          </Grid>
          {props.showDeclineWarning && (
            <Grid item xs={10}>
              <div className={styles.warning}>
                {props.t("BusinessSettings.bodyTextDecline")}
              </div>
            </Grid>
          )}
          {props.dealersActioned.length > 0 && (
            <Grid item xs={10}>
              <div className={styles.subheader}>
                {props.customText ? (
                  props.customText["actioned"]
                ) : (
                  <div>
                    {props.t("PendingActionPrompt.appliedBranches")}
                    {props.title}
                    {props.t("PendingActionPrompt.appliedBranches2")}
                  </div>
                )}
              </div>
            </Grid>
          )}
          {props.dealersActioned.length > 0 && (
            <Grid item xs={10}>
              <Grid container className={styles.dealerContainer}>
                {props.dealersActioned.map((dealer) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      data-testid={`${dealer.dealerId}_actioned`}
                      key={dealer.dealerId}
                      className={styles.dealerName}
                    >
                      {dealer.dealerName} {dealer.termsStatus}
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          )}
          {props.dealersNotActioned.length > 0 && (
            <Grid item xs={10}>
              <div className={styles.subheader}>
                {props.customText ? (
                  props.customText["notActioned"]
                ) : (
                  <div>
                    {props.t("PendingActionPrompt.notAppliedBranches")}
                    {props.title}
                    {props.t("PendingActionPrompt.notAppliedBranches2")}
                  </div>
                )}
              </div>
            </Grid>
          )}
          {props.dealersNotActioned.length > 0 && (
            <Grid item xs={10}>
              <Grid container className={styles.dealerContainer}>
                {props.dealersNotActioned.map((dealer) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      key={dealer.dealerId}
                      data-testid={`${dealer.dealerId}_notActioned`}
                      className={styles.dealerName}
                    >
                      {dealer.dealerName}
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          )}
          <Grid item xs={10} className={styles.actionButtons}>
            <Button
              onClick={props.onClose}
              className={styles.cancelBtn}
              variant="contained"
            >
              {props.t("PendingActionPrompt.cancel")}
            </Button>
          </Grid>
          {props.dealersNotActioned.length > 0 &&
            props.dealersActioned.length > 0 && (
              <Grid item xs={10} className={styles.actionButtons}>
                <Button
                  className={styles.applyBtn}
                  onClick={() => props.applySome()}
                  variant="contained"
                >
                  {props.customText ? (
                    props.customText["applySelective"]
                  ) : (
                    <div>
                      {props.t("PendingActionPrompt.applySelective")}{" "}
                      {props.buttonTitle}
                    </div>
                  )}
                </Button>
              </Grid>
            )}
          <Grid item xs={10} className={styles.actionButtons}>
            <Button
              className={styles.applyBtn}
              onClick={() => props.applyAll()}
              variant="contained"
            >
              {props.t("PendingActionPrompt.applyAll")}
            </Button>
          </Grid>
        </StyledGrid>
      </StyledDialog>
    )
  );
};

export default PendingActionPrompt;
